module.exports = __webpack_public_path__ + "img/milchschaum.9aa79545.jpg";